import React, { useState, useEffect } from 'react';
import './AllForVote.scss';

import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';

import { IComponentVote } from '../../component';
import Vote from './Vote';
import VotePopup from './VotePopup';
import {direct} from '../../utils/image';
import intl from 'react-intl-universal';
import moment from 'moment';

import { getPageSameType } from '../../utils/util';

const AllForVote = (props: IComponentVote) => {
  let { voteStore, imStore, uiStore, wxuserStore } = props.rootStore!;
  const {
    vote_id,
    mode,
    show_search,
    show_count,
    show_result,
    show_bigpic,
    showtype,
    button_text,
    static_order,
    container
  } = props;

  const [showEmpty, setShowEmpty] = useState(false);

  useEffect(() => {
    const onVoteStatus = (data: any) => {
      console.log(`on vote change`, data);
      if (data && Number(data.vote_id) == Number(vote_id)) {
        let update = {
          status: data.status
        } as {
          status: string | number;
          begin_at?: string;
          end_at?: string;
        };
        if (Number(data.status) == 1) {
          update.begin_at = moment().format('YYYY-MM-DD HH:mm:00');
        }
        if (Number(data.status) == 2) {
          update.end_at = moment().format('YYYY-MM-DD HH:mm:00');
        }
        voteStore.updateData(vote_id, update);
      }
    };

    const onVoteCount = (data: any) => {
      console.log(`on vote count`, data);
      if (data && Number(data.vote_id) == Number(vote_id)) {
        voteStore.updateCount(vote_id, data.vote_value);
      }
    };

    if (vote_id) {
      imStore.addMessageListener('vote_status_change', onVoteStatus);
      imStore.addMessageListener('vote_count', onVoteCount);
      voteStore.checkVote(vote_id);
    } else {
      setShowEmpty(true);
    }

    return () => {
      imStore.removeMessageListener('vote_status_change', onVoteStatus);
      imStore.removeMessageListener('vote_count', onVoteCount);
    };
  }, [vote_id]);

  const onVote = (target: string) => {
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return;
    }
    voteStore.addRecord(Number(vote_id), target).then((res: any) => {
      if (res) {
        console.log(res);
        uiStore.showToast({
          content: `投票成功，剩余${res[`re-limit`] || 0}次`
        });
      }
    });
  };

  const data = voteStore.getVote(Number(vote_id));

  const [voteData, setVoteData] = useState(null as any);

  const loadImages = async (source:any)=>{
    const loadImage = async (src:string)=>{
      return await (new Promise(resolve=>{
        let image = new Image();
        image.onload = ()=>{
          resolve({
            width:image.width || 0,
            height:image.height || 0
          });
        };
        image.src = direct(src);
      }));
    };

    let res = {
      ...source
    };
    if(res && res.content && res.content.length) {
      for(let i=0;i<res.content.length;i++) {
        let item = res.content[i];
        const rect = await loadImage(item.image) as any;
        item = {
          ...item,
          ...rect
        };
        res.content[i] = item;
      }
    }

    setVoteData(res);
  }

  useEffect(()=>{
    if(data) {
      if (!wxuserStore.user.is_mock) {
        voteStore.checkUserVote(vote_id, !!Number(data.bool_loop));
      }
      // 检测是否为图片投票，并且当前要求瀑布流显示
      if(String(data.type) == '2' && showtype == 'waterflow') {
        loadImages(data);
      }else {
        setVoteData(data);
      }
    }
  }, [data]);

  const renderVote = () => {
    let renderList = [];
    if (voteData) {
      console.log(`vote config`, mode);
      if (mode == 'normal') {
        renderList.push(
          <Vote
            data={voteData}
            mode={mode}
            show_search={show_search}
            show_count={show_count}
            show_result={show_result}
            button_text={button_text}
            static_order={static_order}
            show_bigpic={show_bigpic}
            showtype={showtype}
            onVote={onVote}
            backgroundColor={container && !container.useThemeColor ? container.componentBg : undefined}
            key="normal"
          />
        );
      }

      renderList.push(
        <VotePopup
          data={voteData}
          mode={mode}
          show_search={show_search}
          show_count={show_count}
          show_result={show_result}
          button_text={button_text}
          static_order={static_order}
          show_bigpic={show_bigpic}
          showtype={showtype}
          onVote={onVote}
          backgroundColor={container && !container.useThemeColor ? container.componentBg : undefined}
          key="popup"
        />
      );
    }

    return renderList;
  };

  return (
    <div
      className="all-for-vote"
      style={{
        paddingBottom: container
          ? Number(container.top) + Number(container.bottom)
          : 0
      }}
    >
      {showEmpty ? (
        <div className="vote-empty">未找到投票活动</div>
      ) : (
        renderVote()
      )}
    </div>
  );
};

export default inject('rootStore')(observer(AllForVote));
